import { IDirectoryRecord } from '../directory.state';

export enum TeamsActions {
    GET_TEAMS_CONTACTS = 'GET_TEAMS_CONTACTS',
    TEAMS_CONTACTS_LOADING = 'TEAMS_DATA_LOADING',
    GET_TEAMS_STATUSES = 'GET_TEAMS_STATUSES',
    TEAMS_ERROR = 'TEAMS_ERROR',
    TEAMS_STATUSES_LOADING = 'TEAMS_STATUSES_LOADING',
}
// shape of the Teams contact in the response
export interface ITeamsContactResponse {
    businessPhones?: string[];
    displayName?: string;
    givenName?: string;
    jobTitle?: string;
    department?: string;
    mail?: string;
    mobilePhone?: string;
    officeLocation?: string;
    preferredLanguage?: string;
    surname?: string;
    userPrincipalName?: string;
    id: string;
}

export interface ITeamsRecord extends IDirectoryRecord {
    userPrincipalName?: string;
    preferredLanguage?: string;
    displayName?: string;
    jobTitle?: string;
    officeLocation?: string;
    statusInfo?: Partial<ITeamsStatusResponse>;
}

export interface ITeamsStatusResponse {
    '@odata.type': string;
    activity: string;
    availability: string;
    id: string;
}

export interface ITeamsStatusInfo {
    [index: string]: Partial<ITeamsStatusResponse>;
}

export interface ITeamsLinks {
    contactsLink: string;
    statusesLink: string;
    statusesMetadata: IMetadata;
    contactsMetadata: IMetadata;
}

export interface IMetadata {
    lastModified: string;
    updateTimeDelta: number;
}

export type ITeamsContactStatus = Pick<ITeamsStatusResponse, 'availability'>;

export interface ITeams {
    contacts: ITeamsRecord[];
    contactsStatuses: ITeamsStatusInfo;
    isTeamsContactsLoading?: boolean;
    isTeamsStatusesLoading?: boolean;
    errors: string[];
}
